<template>
  <div>
    <panier></panier>
    <v-form v-model="valid" ref="mainForm" class="mt-6">
      <opq-catalogue
        :opq-if="estRenouvellement"
        code="paiement-mode"
        v-model="sasInscriptionTableauRegistre.modeDePaiement"
        :code-filter="sas.modesDePaiementsAccessibles"
        :live="liveSasInscriptionTableauRegistre(2305)"
      ></opq-catalogue>
      <opq-catalogue
        :opq-if="estRenouvellement && estRegulier"
        code="paiement-nombre-versements"
        v-model="sasInscriptionTableauRegistre.nombreDeVersement"
        :code-filter="sas.nombreDeVersementAccessibles"
        :live="liveSasInscriptionTableauRegistre(2306)"
        @eudo-updated="nombreDeVersementChanged"
      ></opq-catalogue>
      <div v-if="panier && estDeuxVersement">
        <p class="mb-0 font-weight-bold">Premier versement: {{ montant1de2 | money }}.</p>
        <p class="mb-0 font-weight-bold">Deuxième versement: {{ montant2de2 | money }}.</p>
      </div>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import Panier from "@/components/FormParts/Panier"
import { mapActions, mapGetters } from "vuex"
export default {
  mixins: [CataloguesHelper, FormSimple],
  props: {
    sas: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(["panier", "montant1de2", "montant2de2"]),
    sasInscriptionTableauRegistre() {
      return this.sas.sasInscriptionAuTableauRegistre
    },
    estRenouvellement() {
      return this.estType(2)
    },
    estRegulier() {
      return this.estCategorie(11) || this.estCategorie(21) || this.estCategorie(23)
    },
    estDeuxVersement() {
      return this.getCatalogueCodeById(14104, this.sasInscriptionTableauRegistre.nombreDeVersement) == "02"
    }
  },
  components: {
    Panier
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasInscriptionTableauRegistre(cle) {
      return { endpoint: "sas-inscriptions-tableau-registre", cle: cle, fileId: this.sasInscriptionTableauRegistre.id }
    },
    estType(codeType) {
      return this.getCatalogueCodeById(2312, this.sas.sasInscriptionAuTableauRegistre.typeDInscription) == codeType
    },
    estCategorie(codeCategorie) {
      return this.getCatalogueCodeById(11124, this.sas.sasInscriptionAuTableauRegistre.typeDeCotisation) == codeCategorie
    },
    async nombreDeVersementChanged() {
      await this.fetchPanier(this.sas.id)
    }
  }
}
</script>

<style>
</style>